var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8121",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0015 49.0253C20.2487 49.0285 15.6019 47.6215 11.6492 44.9824C7.69651 42.3433 4.61575 38.5907 2.79693 34.1998C0.978106 29.8088 0.503018 24.9769 1.43181 20.3158C2.3606 15.6546 4.6515 11.3739 8.01449 8.01549C10.5218 5.51083 13.5523 3.59195 16.8886 2.39643C20.2249 1.20091 23.7843 0.758353 27.3118 1.1005C30.8393 1.44265 34.2473 2.56102 37.2917 4.37543C40.336 6.18985 42.9412 8.65536 44.9205 11.5952C46.8997 14.535 48.204 17.8764 48.7398 21.3797C49.2756 24.8829 49.0297 28.4614 48.0196 31.8584C47.0096 35.2555 45.2605 38.3869 42.8976 41.0284C40.5348 43.6698 37.6168 45.7557 34.3529 47.1366C31.3947 48.3892 28.214 49.0316 25.0015 49.0253ZM20.6718 13.6882C20.4833 13.6881 20.2962 13.7209 20.119 13.7851C15.0577 15.6469 11.7889 20.1431 11.7889 25.2385C11.7889 32.0231 17.6719 37.5417 24.9063 37.5417C32.1379 37.5417 38.0196 32.0231 38.0196 25.2385C38.0196 20.1418 34.7491 15.6469 29.6878 13.7851C29.3079 13.6467 28.8897 13.6568 28.5169 13.8135C28.1441 13.9702 27.8442 14.2618 27.6772 14.63C27.5994 14.8178 27.5609 15.0196 27.5641 15.2228C27.5673 15.4261 27.6121 15.6265 27.6957 15.8118C27.7794 15.997 27.9001 16.1632 28.0504 16.3C28.2008 16.4368 28.3776 16.5414 28.5699 16.6072C32.4078 18.0172 34.8882 21.405 34.8882 25.2385C34.8882 30.3557 30.4098 34.5203 24.9062 34.5203C19.3999 34.5203 14.9201 30.3557 14.9201 25.2385C14.9201 21.4064 17.4005 18.0172 21.2371 16.6072C21.5291 16.5031 21.7821 16.3121 21.9622 16.0599C22.1423 15.8077 22.2408 15.5063 22.2445 15.1964C22.2455 15.0008 22.207 14.8069 22.1312 14.6265C22.0069 14.3441 21.8023 14.1046 21.5427 13.9377C21.2832 13.7709 20.9803 13.6841 20.6718 13.6882ZM24.906 11.3104C24.0256 11.3104 23.3376 11.8898 23.3376 12.631V24.2743C23.3376 25.0165 24.0256 25.5983 24.906 25.5983C25.7836 25.5983 26.4685 25.0169 26.4685 24.2743V12.6311C26.4689 11.8899 25.7836 11.3104 24.906 11.3104Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout_white.a21341976fac7411c96587823d7be5a2.svg";
export { ForwardRef as ReactComponent };